import axios from 'axios';

async function carregarMenu(): Promise<any> {
  const res = await axios.get(`${process.env.REACT_APP_MENU_API}`, {
    headers: { Authorization: `${localStorage.getItem('tokenIES')}` },
  });

  localStorage.setItem('menuIES', JSON.stringify(res.data));

  const redirectUrl = res.data.paginaInicial;
  return redirectUrl;
}

export default carregarMenu;
